import React from 'react';
import { Portal } from './Portal.mjs';

function OptionalPortal({ withinPortal = true, children, ...others }) {
  if (withinPortal) {
    return /* @__PURE__ */ React.createElement(Portal, { ...others }, children);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
}

export { OptionalPortal };
